import GoodAndRetunsListController from 'pages/Controller/GoodAndRetunsListController';
import React, { useCallback } from 'react';
import { debounce } from 'lodash';
// import Select from 'react-select';
// import { Grid, Table, TableBody, TableRow, TableCell, TableHead } from '@mui/material';
import { Box, Button, Card } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
} from "@mui/material";

import { GridOverlay } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";

import Loader from 'utils/Loader';

function GoodAndReturnsList() {
  const {
    deliveryNumber,
    invoiceNumber,
    customerCode,
    setDeliveryNumber,
    setInvoiceNumber,
    setCustomerCode,
    cloading,
    columns,
    goodsReturnsListData,
    openViewDialog,
    materialList,
    materialLoading,
    handleCloseView,

    // Status history dialog props
    openStatusDialog,
    statusHistory,
    statusHistoryLoading,
    handleCloseStatus,
  } = GoodAndRetunsListController();

  // Debounced handlers for text inputs
  const debouncedSetDeliveryNumber = useCallback(
    debounce((value) => setDeliveryNumber(value), 500),
    []
  );

  const debouncedSetInvoiceNumber = useCallback(
    debounce((value) => setInvoiceNumber(value), 500),
    []
  );

  const debouncedSetCustomerCode = useCallback(
    debounce((value) => setCustomerCode(value), 500),
    []
  );

  const navigate = useNavigate();

  const CustomNoRowsOverlay = () => {
    return (
      <GridOverlay
        sx={{
          flexDirection: "column",
          "& .MuiTypography-root": {
            mt: 1,
            color: "text.secondary",
            fontWeight: 500,
          },
        }}
      >
        <Typography>No Data Found!</Typography>
      </GridOverlay>
    );
  };

  const formatDateTime = (value) => {
    if (!value) return "-";

    const d = new Date(value);
    if (isNaN(d)) return value;

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // convert 0 → 12
    hours = String(hours).padStart(2, "0");

    return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
  };


  return (
    <div
      className="bg"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px 16px',
      }}
    >
      {/* Loader */}
      {cloading ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please Wait....</span>
        </div>
      ) : null}

      <div className="cutrange" style={{ width: '100%', maxWidth: 1500 }}>
        <span className="font20">GOOD RETURNS</span>
      </div>

      <Card sx={{ width: "100%", p: 1 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: 1500,
            mx: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // ✅ vertical center happens here
            // minHeight: 64,
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField label="Delivery Number" value={deliveryNumber} onChange={(e) => debouncedSetDeliveryNumber(e.target.value)} />
            <TextField label="Invoice Number" value={invoiceNumber} onChange={(e) => debouncedSetInvoiceNumber(e.target.value)} />
            {/* <TextField label="Customer Code" value={customerCode} onChange={(e) => debouncedSetCustomerCode(e.target.value)} /> */}
          </Box>

          <Box sx={{ display: "flex", gap: 2, flexDirection: "row" }}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              sx={{ width: 150, height: 40 }}
              onClick={() => {
                setDeliveryNumber("");
                setInvoiceNumber("");
              }}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              color="info"
              size="small"
              sx={{ width: 150, height: 40 }}
              onClick={() => navigate("/good-returns")}
            >
              Add Return
            </Button>
          </Box>
        </Box>
      </Card>



      {/* Dropdown centered */}
      {/* <div style={{ width: '100%', maxWidth: 900, marginTop: 16, display: 'flex', justifyContent: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <label htmlFor="returnOption" style={{ fontWeight: 600 }}>Select Return Option:</label>
          <Grid item xs={12} sm={4} md={4}>
            <Select
              id="returnOption"
              value={selectedOption}
              options={returnOptions}
              onChange={onOptionChange}
              className="inp_text"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            ></Select>
          </Grid>
        </div>
      </div> */}

      {/* Centered textarea */}
      {/* <Grid container justifyContent="center" style={{ marginTop: 18 }} spacing={2}>
        <Grid item xs={12} sm={8} md={10}>
          <textarea
            name="barcodes"
            value={value}
            className={`form-control inp_text`}
            id="barcodes"
            rows={8}
            cols={50}
            onChange={handleChange}
            onInput={handleTextareaResize}
            autoFocus
            placeholder={getPlaceholder()}
            style={{ width: '100%', boxSizing: 'border-box', resize: 'vertical' }}
          />
        </Grid>

        <Grid item xs={12} sm={8} md={2} display="flex" flexDirection="column" alignItems="end" justifyContent="end">
          <button onClick={handleClearButtonClick} style={{ marginRight: '15px', marginBottom: '10px' }}>
            {'Clear'}
          </button>

          <button style={{ marginRight: '15px', marginBottom: '10px' }} onClick={handleProceed}>
            {'Submit'}
          </button>
        </Grid>
      </Grid> */}
      {/* <div style={{ width: '100%', maxWidth: 900, marginTop: 18, display: 'flex', justifyContent: 'center' }}>
        <div style={{ flex: 1, width: '100%' }}>
          <textarea
            name="barcodes"
            value={value}
            className={`form-control inp_text`}
            id="barcodes"
            rows={8}
            cols={50}
            onChange={handleChange}
            onInput={handleTextareaResize}
            autoFocus
            placeholder={getPlaceholder()}
            style={{ width: '100%', boxSizing: 'border-box', resize: 'vertical' }}
          />
        </div>
      </div>

      <div className="footer-button" style={{ marginTop: 20 }}>
        <button onClick={handleClearButtonClick} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleProceed}>
          {'Submit'}
        </button>
      </div> */}

      <div style={{ marginTop: 12, width: "100%" }}>
        {/* {goodsReturnsListData && goodsReturnsListData.length > 0 && ( */}
        <Box sx={{ width: "100%" }}>
          <Card sx={{ width: "100%" }}>
            <DataGrid
              getRowId={(row) => row.grInvoiceDtlsId}
              rows={goodsReturnsListData}
              columns={columns}
              autoHeight
              getRowHeight={() => 'auto'}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableRowSelectionOnClick
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  whiteSpace: 'normal',
                  lineHeight: 1.2,
                  fontWeight: 600
                },
                '& .MuiDataGrid-columnHeader': {
                  alignItems: 'center'
                },
                '& .MuiDataGrid-cell': {
                  whiteSpace: 'normal !important',
                  wordBreak: 'break-word',
                  overflowWrap: 'anywhere',
                  lineHeight: 1.25,
                  py: 1,
                  display: 'flex',
                  alignItems: 'center'
                },
                '& .MuiDataGrid-cellContent': {
                  whiteSpace: 'normal !important',
                  wordBreak: 'break-word',
                  overflowWrap: 'anywhere',
                  textOverflow: 'clip',
                  overflow: 'visible'
                },
                '& .MuiDataGrid-row': {
                  maxHeight: 'none !important'
                }
              }}
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
              }}
            />
          </Card>
        </Box>
        {/* )} */}
      </div>


      <Dialog
        open={openViewDialog}
        onClose={handleCloseView}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            m: 2,
            width: "90%",
            maxWidth: "1100px"
          }
        }}
      >
        <DialogTitle sx={{ textAlign: "center" }}>Goods Return Details</DialogTitle>

        <DialogContent dividers>
          <Table size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell>Order No</TableCell> */}
                <TableCell>Material Code</TableCell>
                <TableCell>Material Description</TableCell>
                <TableCell>Barcode</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Cut</TableCell>
                <TableCell>Division</TableCell>
                <TableCell>Batch</TableCell>
                {/* <TableCell>HOD Status</TableCell>
                <TableCell>All Div HOD</TableCell>
                <TableCell>Sales Acc</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {materialLoading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                    Loading materials...
                  </TableCell>
                </TableRow>
              ) : materialList.length > 0 ? (
                materialList.map((row, index) => (
                  <TableRow key={row.id || index}>
                    <TableCell>{row.material_code}</TableCell>
                    <TableCell>{row.material_description}</TableCell>
                    <TableCell>{row.barcode}</TableCell>
                    <TableCell>{row.quantity}</TableCell>
                    <TableCell>{row.cut_qty}</TableCell>
                    <TableCell>{row.division}</TableCell>
                    <TableCell>{row.batch}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 2, fontWeight: 500 }}>
                    No Data Found!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>


          </Table>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseView} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openStatusDialog}
        onClose={handleCloseStatus}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>Status History</DialogTitle>

        <DialogContent dividers>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User Name</TableCell>
                <TableCell>Designation</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Remark</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {statusHistoryLoading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 3 }}>
                    Loading...
                  </TableCell>
                </TableRow>
              ) : statusHistory && statusHistory.length > 0 ? (
                statusHistory.map((row, index) => (
                  <TableRow key={index}>
                    {/* <TableCell>{row.userName || row.user ? `${row.userName || row.user}${row.userCode ? ' - ' + row.userCode : ''}` : '-'}</TableCell> */}
                    <TableCell>{row.userName || row.user ? `${row.userName || row.user}` : '-'}</TableCell>
                    <TableCell>{row.role || row.designation || '-'}</TableCell>
                    <TableCell>{row.status || '-'}</TableCell>
                    <TableCell>{row.remark || '-'}</TableCell>
                    <TableCell>{formatDateTime(row.created_at || row.statusDate || row.date || '-')}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center" sx={{ py: 2, fontWeight: 500 }}>
                    No Data Found!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>

          </Table>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseStatus} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

export default GoodAndReturnsList;
